import { BodyText, Button, Label } from "@/components/ui";

import { HeaderText } from "@/components/ui";
import { formatDateTime } from "@/lib/time";
import { useS3SyncDownload } from "@/network/useS3SyncDownload";
import type { DiagnosticReport } from "@curai/js-fhir-tools";
import type { RequestGroup } from "@curai/js-fhir-tools";
import { FileDown } from "lucide-react";

export const OrderDetails = ({
  diagnosticReport,
  requestGroup,
}: {
  diagnosticReport?: DiagnosticReport;
  requestGroup?: RequestGroup;
}) => {
  const { mutateAsync: downloadOrderRequisition, isPending: isDownloadingPdf } =
    useS3SyncDownload();

  return (
    <div className="grid grid-cols-2 gap-2">
      {diagnosticReport && (
        <div className="flex flex-col">
          <HeaderText size="sm">Results Status</HeaderText>
          <BodyText size="sm">{diagnosticReport?.statusLabel}</BodyText>
        </div>
      )}
      <div className="flex flex-col">
        <HeaderText size="sm">Lab Network</HeaderText>
        <BodyText size="sm">
          {requestGroup?.labNetworkLabel || "Quest Diagnostics"}
        </BodyText>
      </div>
      {requestGroup?.authoredOn && (
        <div className="flex flex-col">
          <HeaderText size="sm">Ordered On</HeaderText>
          <BodyText size="sm">
            {formatDateTime(requestGroup.authoredOn)}
          </BodyText>
        </div>
      )}
      {requestGroup?.author && (
        <div className="flex flex-col">
          <HeaderText size="sm">Ordered By</HeaderText>
          <BodyText size="sm">{requestGroup.author.display}</BodyText>
        </div>
      )}
      <div className="flex flex-col">
        <HeaderText size="sm">Billing Method</HeaderText>
        <BodyText size="sm">{requestGroup?.billingMethodLabel}</BodyText>
      </div>
      {requestGroup?.accessionNumber && (
        <div className="flex flex-col">
          <HeaderText size="sm">Accession Number</HeaderText>
          <BodyText size="sm">{requestGroup?.accessionNumber}</BodyText>
        </div>
      )}
      {!!requestGroup?.icd10Codes?.length && (
        <div className="col-span-2 grid">
          <Label>ICD10 Codes</Label>
          <BodyText size="sm">
            <ul className="list-outside list-disc pl-5">
              {requestGroup?.icd10Codes?.map((code) => (
                <li key={`${code.id}-${code.text}`}>
                  {`${code.coding?.[0]?.code} - ${code.text}`}
                </li>
              ))}
            </ul>
          </BodyText>
        </div>
      )}
      {requestGroup?.orderRequisitions?.map((requisition) => (
        <div className="flex flex-col col-span-2" key={requisition.url}>
          <Button
            isLoading={isDownloadingPdf}
            hideTextOnLoading={false}
            key={`${requisition.url}`}
            className="w-fit"
            size="sm"
            variant="link"
            leftIcon={FileDown}
            onClick={() => {
              downloadOrderRequisition({
                path: requisition.url as string,
              }).then((data) => {
                const url = URL.createObjectURL(data);
                window.open(url, "_blank");
              });
            }}
          >
            Order Requisition
          </Button>
        </div>
      ))}
    </div>
  );
};
